import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Motion, spring } from 'react-motion';

class QProgressBar extends React.PureComponent {

  render() {
    let progress;
    let label = this.props.label === '' && ' ';
    if (this.props.value * this.props.max > 0) {
      const value = Math.abs(this.props.value);
      const max = Math.abs(this.props.max);
      progress = Math.round((value * 100) / max);
      label = label || `${progress}%`;
      if (value > max) {
        progress = 100;
      }
    } else if (this.props.value !== 0 && this.props.max === 0) {
      progress = 100;
      label = label || '';
    } else {
      progress = 0;
      label = label || '';
    }

    return (
      <div
        id={this.props.id}
        variant="body2"
        component="div"
        style={{
          display: 'inline-block',
          backgroundColor: this.props.backgroundColor,
          borderRadius: !this.props.noRoundCorners && '4px',
          boxShadow: !this.props.noShadow && '0 2px 5px rgba(0, 0, 0, 0.25) inset',
          ...this.props.style,
        }}
      >
        <Motion
          defaultStyle={{ progress: 0 }}
          style={{ progress: spring(progress, { stiffness: 300, damping: 30, precision: 1 }) }}
        >
          {(value) => (
            <div
              style={{
                borderRadius: !this.props.noRoundCorners && '4px',
                width: `${value.progress}%`,
                height: this.props.style.height,
                lineHeight: this.props.style.height + 1,
                backgroundColor: this.props.color,
                textAlign: 'center',
                color: this.props.textColor,
              }}
            >
              {(progress > 2 && label !== ' ' && label) || <span>&nbsp;</span>}
            </div>
          )}
        </Motion>
      </div>
    );
  }
}

QProgressBar.propTypes = {
  value: PropTypes.number,
  max: PropTypes.number,
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  style: PropTypes.object,
  label: PropTypes.string,
  noRoundCorners: PropTypes.bool,
  noShadow: PropTypes.bool,
  id: PropTypes.string,
};

function mapStateToProps(_state, props) {
  return {
    value: Number.isNaN(props.value) ? undefined : props.value,
    max: Number.isNaN(props.max) ? 100 : props.max,
    color: props.color || 'blue',
    backgroundColor: props.backgroundColor || 'whiteSmoke',
    textColor: props.textColor || 'white',
    style: { width: '100%', height: '22px', ...props.style },
  };
}

export default connect(mapStateToProps, null)(QProgressBar);
